exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,800,900&display=swap);", ""]);

// module
exports.push([module.id, ".Image-module__img___3HK-l{width:100%;margin:10px 0;display:block}", ""]);

// exports
exports.locals = {
	"img": "Image-module__img___3HK-l"
};